var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { cuppingComment as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { getCurrentUser } from '../../../localStorage';
import UserCuppingComments from './UserCuppingComments';
import { CommentsBox } from './CommentBox';
import CommentsSummary from './CommentsSummary';
import Button from '../../atoms/BaseButton';
import CuppingCommentForm from './CuppingCommentForm';
import Comment from './Comment';
var Sticky = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: sticky;\n  bottom: 0;\n  padding: 16px 0;\n  background-color: white;\n  text-align: center;\n"], ["\n  position: sticky;\n  bottom: 0;\n  padding: 16px 0;\n  background-color: white;\n  text-align: center;\n"])));
var CuppingComments = function (_a) {
    var editable = _a.editable, orderedItem = _a.orderedItem, selectedUser = _a.selectedUser, showCuppingCommentForm = _a.showCuppingCommentForm, onSelectedUserChange = _a.onSelectedUserChange, onShowForm = _a.onShowForm, onOrderedItemChange = _a.onOrderedItemChange, onClose = _a.onClose;
    var t = useTranslation().t;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState([]), comments = _c[0], setComments = _c[1];
    var _d = React.useState({}), descriptorSummary = _d[0], setDescriptorSummary = _d[1];
    var _e = React.useState(0), loadCount = _e[0], setLoadCount = _e[1];
    var getAllApi = useRequest(api.getAll);
    var currentUser = getCurrentUser();
    React.useEffect(function () {
        var unmounted = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!orderedItem)
                            return [2 /*return*/];
                        setLoading(true);
                        return [4 /*yield*/, getAllApi({
                                q: { offer_id_eq: orderedItem.offer.id },
                            })];
                    case 1:
                        response = _a.sent();
                        if (unmounted || !response)
                            return [2 /*return*/];
                        setLoading(false);
                        setComments(response.data);
                        setDescriptorSummary(response.meta.cuppingDescriptors);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            unmounted = true;
        };
    }, [orderedItem, getAllApi, loadCount, onSelectedUserChange]);
    var myComment = React.useMemo(function () { return comments.find(function (comment) { return comment.user.id === currentUser.id; }); }, [currentUser.id, comments]);
    var handleCreate = React.useCallback(function (cuppingComment) {
        setLoadCount(function (oldCount) { return oldCount + 1; });
        if (!orderedItem)
            return;
        onOrderedItemChange(__assign(__assign({}, orderedItem), { offer: __assign(__assign({}, orderedItem.offer), { cuppingScoreAverage: cuppingComment.offer.cuppingScoreAverage, cuppingCommentsCount: cuppingComment.offer.cuppingCommentsCount }) }));
    }, [orderedItem, onOrderedItemChange]);
    var handleUpdate = React.useCallback(function (cuppingComment) {
        setLoadCount(function (oldCount) { return oldCount + 1; });
        if (!orderedItem)
            return;
        onOrderedItemChange(__assign(__assign({}, orderedItem), { offer: __assign(__assign({}, orderedItem.offer), { cuppingScoreAverage: cuppingComment.offer.cuppingScoreAverage, cuppingCommentsCount: cuppingComment.offer.cuppingCommentsCount }) }));
    }, [orderedItem, onOrderedItemChange]);
    var handleDelete = React.useCallback(function (cuppingComment) {
        setLoadCount(function (oldCount) { return oldCount + 1; });
        if (!orderedItem)
            return;
        onOrderedItemChange(__assign(__assign({}, orderedItem), { offer: __assign(__assign({}, orderedItem.offer), { cuppingScoreAverage: cuppingComment.offer.cuppingScoreAverage, cuppingCommentsCount: cuppingComment.offer.cuppingCommentsCount }) }));
    }, [orderedItem, onOrderedItemChange]);
    if (!orderedItem)
        return null;
    if (selectedUser)
        return (React.createElement(UserCuppingComments, { user: selectedUser, offerList: orderedItem.offer.offerList, onClose: onClose }));
    if (editable && showCuppingCommentForm) {
        return (React.createElement(CuppingCommentForm, { offerId: orderedItem.offer.id, comment: myComment, loading: loading, onLoading: setLoading, onCreated: handleCreate, onUpdated: handleUpdate, onDeleted: handleDelete }));
    }
    return (React.createElement(Stack, { justifyContent: "space-between", sx: { backgroundColor: '#FFF', height: '100%' } },
        React.createElement(Box, null,
            comments.length > 0 && (React.createElement(CommentsSummary, { comments: comments, scoreAverage: orderedItem.offer.cuppingScoreAverage, descriptorSummary: descriptorSummary })),
            React.createElement(CommentsBox, null,
                comments.length === 0 && (React.createElement(Typography, { sx: { p: 3 } }, t('pages.roasterOrder.noComments'))),
                comments.map(function (comment) { return (React.createElement(Comment, { key: comment.id, comment: comment, onSelectUser: function (user) { return onSelectedUserChange(user); }, selectedUser: undefined })); }))),
        editable && (React.createElement(Sticky, { style: {
                padding: '20px 24px',
                boxShadow: '0 -1px 0 rgba(145, 158, 171, .24)',
            } },
            React.createElement(Button, { size: "large", onClick: function () { return onShowForm(true); }, disabled: loading, fullWidth: true }, myComment
                ? t('pages.roasterOrder.updateComment')
                : t('pages.roasterOrder.postComment'))))));
};
export default CuppingComments;
var templateObject_1;
